import {
    combineReducers
  } from 'redux';
  
//面包屑 及 模块的 [index]
const router = (state = {sitemap: [], index: -1}, action) => {
    switch (action.type) {
        case 'UPDATE_ROUTER':
        return action.router;
        default:
        return state;
    }
};

//用户登录
const login = (state = {}, action) => {
    switch (action.type) {
        case 'APPS_LOGIN':
        return action.user;
        default:
        return state;
    }
};

//用户登录
const collapse = (state = false, action) => {
    switch (action.type) {
        case 'APPS_MENU':
        return action.collapse;
        default:
        return state;
    }
};

const find = (tabs, tab) => {
    var size = tabs.length;
    var index = -1;
    for(var i = 0; i < size; i++) {
        if(tabs[i].label === tab.label) {
            index = i;
            break;
        }
    }

    return index;
}


//Tabs
const tabs = (state = [], action) => {
    switch (action.type) {
        case 'INSERT_TAB_ROUTER':
            var index = find(state, action.tab);
            if(index !== -1) {
                const clone = state.map(d => {
                    if(d.active) {
                        return Object.assign({}, d, {active: false})
                    }
                    return d;
                });

                clone[index] = Object.assign({}, action.tab, {active: true});
                return clone;
            } else {
                const list = state.map(d => {
                    if(d.active) {
                        return Object.assign({}, d, {active: false})
                    }
                    return d;
                });
                return [...list, Object.assign({}, action.tab, {active: true})]
            }
        case 'REMOVE_TAB_ROUTER':
        if(action.tab.active === false) {

            return state.filter(menu => (menu.id !== action.tab.id));
        } else {
            return state.filter(menu => (menu.id !== action.tab.id))
            .map((d, i) => {
                if(i === 0) {
                    return Object.assign({}, d, {active: true});
                }
                return d;
            });
        }
        
        default:
        return state;
    }
};

export default combineReducers({
    router,
    login,
    tabs,
    collapse
});